import { render, staticRenderFns } from "./RewardInfo.vue?vue&type=template&id=0d0e43ea&scoped=true&"
import script from "./RewardInfo.vue?vue&type=script&lang=js&"
export * from "./RewardInfo.vue?vue&type=script&lang=js&"
import style0 from "./RewardInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RewardInfo.vue?vue&type=style&index=1&id=0d0e43ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e43ea",
  null
  
)

export default component.exports